import { render, staticRenderFns } from "./ManageSuppliers.vue?vue&type=template&id=09b7fe4d&scoped=true&"
import script from "./ManageSuppliers.vue?vue&type=script&lang=js&"
export * from "./ManageSuppliers.vue?vue&type=script&lang=js&"
import style0 from "./ManageSuppliers.vue?vue&type=style&index=0&id=09b7fe4d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b7fe4d",
  null
  
)

export default component.exports